import { ConfigHelper } from '../../base/constants'
import { getCurrentUserAccountCode } from '../../base/proxy/authenticate'
import { ClientStorage } from '../../base/storage'

/**
 * İlk temas tanıtımının bayrakları.
 *
 * Kalıcı iki bayrak (`introSeen`, `nudgeDismissed`) SAP hesap kodu listesi olarak tutulur —
 * `INDEXPAZAR_OPENED_POPUPS_COMPANYIDS` ile aynı desen. `authenticate.ts` yalnız hesap kodu
 * verdiği için kırılım kullanıcı değil bayi düzeyindedir (bkz. tasarım dokümanı).
 *
 * Oturumluk bayrak `sessionStorage`'da tutulur: `ClientStorage` (expired-storage) yalnız
 * localStorage sarar, sekme kapanınca temizlenen bir kanal sunmaz. Bilinçli sapma.
 */

const SESSION_KEY = 'INDEXPAZAR_CHATBOT_INTRO_SHOWN_THIS_SESSION'

function readAccounts(key: string): string[] {
  const value = ClientStorage.getItem(key)
  return Array.isArray(value) ? value : []
}

function hasAccount(key: string): boolean {
  const account = getCurrentUserAccountCode()
  return !!account && readAccounts(key).includes(account)
}

function addAccount(key: string) {
  const account = getCurrentUserAccountCode()
  if (!account) return
  const accounts = readAccounts(key)
  if (accounts.includes(account)) return
  ClientStorage.setItem(key, [...accounts, account])
}

export function isIntroSeen(): boolean {
  return hasAccount(ConfigHelper.INDEXPAZAR_CHATBOT_INTRO_SEEN_ACCOUNTS)
}

export function markIntroSeen() {
  addAccount(ConfigHelper.INDEXPAZAR_CHATBOT_INTRO_SEEN_ACCOUNTS)
}

export function isNudgeDismissed(): boolean {
  return hasAccount(ConfigHelper.INDEXPAZAR_CHATBOT_NUDGE_DISMISSED_ACCOUNTS)
}

export function markNudgeDismissed() {
  addAccount(ConfigHelper.INDEXPAZAR_CHATBOT_NUDGE_DISMISSED_ACCOUNTS)
}

export function isShownThisSession(): boolean {
  // Safari özel modunda sessionStorage erişimi istisna atabilir; bayrak okunamazsa "tetiklenmedi" sayılır.
  try {
    return window.sessionStorage.getItem(SESSION_KEY) === '1'
  } catch {
    return false
  }
}

export function markShownThisSession() {
  try {
    window.sessionStorage.setItem(SESSION_KEY, '1')
  } catch {
    // Yazılamazsa tanıtım bir kez daha çıkabilir; kırılma olmaz.
  }
}
